import {saveUserLang, loadLanguage} from '@/services/lang.js'

export default {
  data: () => ({
    language: {},
    locale: 'fr',
    // liste des langues disponibles
    langs: [
      {
        "label": "English",
        "key": "en",
        "flag": "gb",
      },
      {
        "label": "Español",
        "key": "es",
        "flag": "es",
      },
      {
        "label": "Français",
        "key": "fr",
        "flag": "fr",
      },
      {
        "label": "Italiano",
        "key": "it",
        "flag": "it",
      }
    ],
  }),
  computed: {},
  methods: {
    async changeLanguage() {
      if (this.locale !== window.V.$localStorage.get('MANAGER_LOCALE')) {
        window.V.$localStorage.set('MANAGER_LOCALE', this.locale);
        this.changeLanguageData();
        await saveUserLang(this.locale);


        // Reload page on language change
        this.$router.go();
      }
    },

    changeLanguageData() {
      this.language = this.langs.find(lang => lang.key === this.locale);
    }
  },
  mounted() {
    if (!window.V.$localStorage.get('MANAGER_LOCALE')) {
      const navigatorLanguage = navigator.language.substring(0, 2);

      let i = 0;
      while (i < this.langs.length) {
        if (navigatorLanguage === this.langs[i].key) {
          this.locale = navigatorLanguage;
          window.V.$localStorage.set('MANAGER_LOCALE', this.locale)
          break;
        }
        i++;
      }
      if (i === this.langs.length) {
        this.locale = 'en';
      }

    } else {
      let lsLocale = window.V.$localStorage.get('MANAGER_LOCALE');
      if (lsLocale) {
        this.locale = lsLocale;
      }
    }

    this.changeLanguageData();
  },
}



// WEBPACK FOOTER //
// ./src/mixins/languages.js